import { render, staticRenderFns } from "./CompanyPoster.vue?vue&type=template&id=740a2e2a&scoped=true&"
import script from "./CompanyPoster.vue?vue&type=script&lang=js&"
export * from "./CompanyPoster.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPoster.vue?vue&type=style&index=0&id=740a2e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a2e2a",
  null
  
)

export default component.exports